module.exports = __webpack_public_path__ + "static/media/windmill-icon.d5b7f690.svg";